export const initDayTabs = (selector) => {
  const elements = document.querySelectorAll(selector);

  if (!elements[0]) return false;

  elements.forEach(element => {
    const buttons = element && element.querySelectorAll('[data-control]');
    const items = element && element.querySelectorAll('[data-item]');

    if (!element || !buttons[0] || !items[0]) return false;

    buttons.forEach(button => button.addEventListener('click', () => {
      const id = button.getAttribute('data-control');

      if (!button.classList.contains('active')) {
        buttons.forEach(currentButton => {
          if (currentButton.getAttribute('data-control') == id) {
            currentButton.classList.add('active');
          } else {
            currentButton.classList.remove('active');
          }
        });

        items.forEach(currentItem => {
          if (currentItem.getAttribute('data-item') == id) {
            currentItem.classList.add('active');
          } else {
            currentItem.classList.remove('active');
          }
        });
      }
    }));
  });

}